import { render, staticRenderFns } from "./oldSetting.vue?vue&type=template&id=7b6e60f6&scoped=true&"
import script from "./oldSetting.vue?vue&type=script&lang=js&"
export * from "./oldSetting.vue?vue&type=script&lang=js&"
import style0 from "./oldSetting.vue?vue&type=style&index=0&id=7b6e60f6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e60f6",
  null
  
)

export default component.exports